// extracted by mini-css-extract-plugin
module.exports = {"container":"_2YhQX","listItem":"_7Rk0P","withoutFooter":"_2bwWZ"};